import { Button, ButtonVariant } from "@next-platform/client-common-spicy-ui";
import { useCallback, useMemo } from "react";

interface ILegendButtonProps {
  label: string;
  index: number;
  color: string;
  textColor: string;
  isHidden: boolean;
  onToggle: (index: number) => void;
}

const HIDDEN_OPACITY = 0.35;

const LegendButton = ({ label, index, color, textColor, isHidden, onToggle }: ILegendButtonProps) => {
  const handleClick = useCallback(() => onToggle(index), [onToggle, index]);
  const dotStyle = useMemo(() => ({ backgroundColor: color }), [color]);
  const labelStyle = useMemo(() => ({ color: textColor }), [textColor]);
  const buttonStyle = useMemo(() => ({ opacity: isHidden ? HIDDEN_OPACITY : 1 }), [isHidden]);

  return (
    <Button
      variant={ButtonVariant.TRANSPARENT}
      onClick={handleClick}
      className="flex items-center gap-2.5 p-0 text-xs transition-opacity"
      style={buttonStyle}
    >
      <span className="mr-1.5 inline-block h-2.5 w-2.5 rounded-full" style={dotStyle} />
      <span className={isHidden ? "line-through" : ""} style={labelStyle}>
        {label}
      </span>
    </Button>
  );
};

export default LegendButton;
